import React from 'react';
import type { CustomTheme } from '../../types/theme';

interface ColorPreviewProps {
  theme: CustomTheme;
}

export function ColorPreview({ theme }: ColorPreviewProps) {
  return (
    <div className="space-y-6 p-6 border rounded-lg">
      <h3 className="text-lg font-medium">Color Preview</h3>
      
      <div className="space-y-4">
        {/* Brand Colors */}
        <div style={{ background: theme.pageBackground }} className="p-4 rounded-lg border">
          <h4 style={{ color: theme.textPrimary }} className="mb-4">Brand Colors</h4>
          <div className="flex gap-4">
            <div className="text-center">
              <div 
                style={{ background: theme.brandPrimary }} 
                className="w-16 h-16 rounded-lg mb-2"
              />
              <span style={{ color: theme.textSecondary }} className="text-sm">Primary</span>
            </div>
            <div className="text-center">
              <div 
                style={{ background: theme.brandSecondary }} 
                className="w-16 h-16 rounded-lg mb-2"
              />
              <span style={{ color: theme.textSecondary }} className="text-sm">Secondary</span>
            </div>
          </div>
        </div>

        {/* UI Elements */}
        <div style={{ background: theme.cardBackground }} className="p-4 rounded-lg border">
          <h4 style={{ color: theme.textPrimary }} className="mb-4">UI Elements</h4>
          <div className="space-y-4">
            <button
              style={{ background: theme.buttonColor, color: '#ffffff' }}
              className="px-4 py-2 rounded-lg"
            >
              Sample Button
            </button>
            <div>
              <a 
                href="#" 
                style={{ color: theme.linkColor }}
                onClick={(e) => e.preventDefault()}
              >
                Sample Link
              </a>
            </div>
          </div>
        </div>

        {/* Text Colors */}
        <div style={{ background: theme.cardBackground }} className="p-4 rounded-lg border">
          <h4 style={{ color: theme.textPrimary }} className="mb-4">Typography</h4>
          <div className="space-y-2">
            <p style={{ color: theme.textPrimary }}>Primary Text Color</p>
            <p style={{ color: theme.textSecondary }}>Secondary Text Color</p>
          </div>
        </div>
      </div>
    </div>
  );
}